<template>
    <b-button
        variant="warning"
        @click.stop="confirmarVoltarEtapaContrato()"
        class="ml-1"
        v-if="mostraBtn"
    >
        <span>
            <i class="fa fa-refresh mr-2"></i> Retornar para etapa anterior
        </span>
    </b-button>
</template>

<script>
import ContratosServicos from './ContratosServicos'
import { situacaoContrato } from './SituacaoContrato'

export default {
    props: {
        contrato: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarVoltarEtapaContrato() {
            this.$swal({
                title: 'Retornar Etapa Contrato',
                html: `Confirma o retorno do contrato <b>${this.contrato.vcCodigoEstruturado}</b> para etapa anterior?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não',
                input: 'textarea',
                inputPlaceholder: 'Informe a justificativa',
                inputValidator: (value) => {
                    if (!value) {
                        return 'A justificativa é obrigatória'
                    }
                }
            }).then((result) => {
                if (result.value) {
                    this.voltarEtapaContrato(result.value)
                }
            })
        },

        voltarEtapaContrato(justificativa) {
            this.$store.dispatch('addRequest')
            let voltarEtapaContratoDto = {
                idContrato: this.contrato.idContrato,
                justificativa: justificativa
            }
            ContratosServicos.voltarEtapaContrato(voltarEtapaContratoDto).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Registro atualizado com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('retornarParaLista')
                        } else {
                            this.$emit(
                                'atualizarMensagensErros',
                                response.errors
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        }
    },

    created() {},

    computed: {
        mostraBtn() {
            return (
                (this.contrato.idSituacaoContrato ==
                    situacaoContrato.PRE_CONTRATO_CONCLUIDO ||
                    this.contrato.idSituacaoContrato ==
                        situacaoContrato.CONTRATO_DISTRIBUIDO_AGUARDANDO_INTEGRACAO ||
                    this.contrato.idSituacaoContrato ==
                        situacaoContrato.ADITIVO_ASSINADO_AGUARDANDO_INTEGRACAO) &&
                (this.$temAcessoView('CONT-ELAB-00') ||
                    this.$temAcessoView('CONT-ELAB-01') ||
                    this.$temAcessoView('CONT-ADITIV-00') ||
                    this.$temAcessoView('CONT-ADITIV-01'))
            )
        }
    },

    watch: {},

    validations: {}
}
</script>
